module.exports = __webpack_public_path__ + "img/jobmule_regioni.c5b6839c.png";